import React, { useEffect, useState } from 'react'
import Button from '../../../../../components/ui/buttons/Button'
import { fetchWithCsrf } from '../../../../../utils/fetchWithCsrf'
import { snakecaseKeys } from '../../../../../utils/snakecaseKeys'
import { camelizeKeys } from '../../../../../utils/camelizeKeys'
import IndicationFormList from '../../../../../components/forms/profileIndication/IndicationFormList'
import { useToast } from '../../../../../components/ui/toast/ToastContext'

const IndicationsTab = ({ clientId, onSuccess, canWrite }) => {
  const [form, setForm] = useState({
    indicationsAttributes: [],
  })
  const [saving, setSaving] = useState(false)
  const { addToast } = useToast()

  useEffect(() => {
    loadIndications()
  }, [clientId])

  const loadIndications = () => {
    fetch(`/app/planner/client/${clientId}/profile/indications`)
      .then(res => res.json())
      .then(data => {
        const camelData = camelizeKeys(data)
        setForm({
          indicationsAttributes: camelData.indicationsAttributes || []
        })
      })
  }  

  const handleSubmit = () => {
    setSaving(true)
    const payload = snakecaseKeys({ client: form })

    fetchWithCsrf(`/app/planner/client/${clientId}/profile/indications`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) throw new Error()
        return res.json()
      })
      .then(() => {
        addToast({ type: 'success', message: 'Indicações salvas com sucesso!' })
        loadIndications()
        onSuccess()
      })
      .catch(() => {
        addToast({ type: 'error', message: 'Erro ao salvar indicações.' })
        loadIndications()
      })
      .finally(() => setSaving(false))
  }

  return (
    <>
      <div className="bg-white rounded-xl p-6 space-y-8">
        <div>
          <h2 className="text-lg font-semibold text-blueDarker mb-4">Indicações</h2>
          <IndicationFormList
            indications={form.indicationsAttributes}
            onChange={(updatedList) =>
              setForm((prev) => ({ ...prev, indicationsAttributes: updatedList }))
            }
            canWrite={canWrite}
          />
        </div>
      </div>

      {canWrite && (
        <div className="flex justify-end mt-8">
          <Button onClick={handleSubmit} loading={saving}>
            SALVAR
          </Button>
        </div>
      )}
    </>
  )
}

export default IndicationsTab
